import SFetch from '@app/utils/sfetch'

export const persistFocusedItem = ({
  accountNumber,
  itemId,
  itemType,
  ledgerId,
  workflowId,
}: {
  accountNumber?: string
  itemId: number
  itemType: 'reconciliation_text' | 'account_entry'
  ledgerId: number
  workflowId: number
}): Promise<void | null> => {
  const url =
    window.Silverfin.Routes.persist_focused_item_ledger_workflow_review_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId,
      ledgerId,
      workflowId,
      itemType === 'reconciliation_text'
        ? {
            item_id: itemId,
            item_type: itemType,
          }
        : {
            item_id: itemId,
            item_type: itemType,
            account_number: accountNumber || '',
          }
    )

  return SFetch.json(url, { method: 'POST' })
}
